function schemeJump(url) {
  let iframe = document.createElement('iframe');
  iframe.src = url;
  iframe.style.display = 'none';
  document.documentElement.appendChild(iframe);
  setTimeout(() => {
    document.documentElement.removeChild(iframe);
  }, 0);
}

export function bridgeCall(type, module, method, args) {
  let url = `fusion://${type}?`;
  if (module) {
    url += `module=${module}&`;
  }

  url += `method=${method}&`;
  let param = args.map((arg) => {
    return encodeURIComponent(JSON.stringify(arg));
  });
  url += `arguments=%5B${param}%5D&`;

  // 添加host
  url += `origin=${window.location.hostname}`;

  schemeJump(url);
}


// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/fusion/src/util/link.js